export const brandReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_BRANDS_LIST_REQUEST":
      return { ...state, loading: true, brands: null };
    case "GET_BRANDS_LIST_SUCCESS":
      return { ...state, loading: false, brands: action.payload };
    case "GET_BRANDS_LIST_FAILED":
      return { ...state, loading: false, brands: action.payload };
    case "ADD_BRANDS_REQUEST":
      return { ...state, loading: true, brands: null };
    case "ADD_BRANDS_SUCCESS":
      return { ...state, loading: false, brands: action.payload };
    case "ADD_BRANDS_FAILED":
      return { ...state, loading: false, brands: action.payload };
    default:
      return state;
  }
};
